export const MIXPANEL_KEY = '62597aa51842e6e2c56b97d96e4c5f8a';
export const MIXPANEL_UAT_LIVE_KEY = '300839ba6e6d53595df366f017df4ec8';
